import React from 'react';
import PropTypes from 'prop-types';
import { getProps } from '../../shared/_helpers';
import DataGridConfig from '../../shared/datagrid/DataGridConfig.js';
import { AvatarComponent } from '../AvatarComponent.jsx';

/**
 * @param {BCPAzureUserDropDown.propTypes} props
 * @return {JSX.Element}
 */
export function BCPAzureUserDropDown(props) {
    let { context, bcpRequest, currentColumnValue, column } = props;
    return (<AvatarComponent
        columnValue={currentColumnValue}
        context={context}
        bcpRequest={bcpRequest}
        property={getProps(column[DataGridConfig.columnNameProp.getTag()])}
    ></AvatarComponent>
    );
}

BCPAzureUserDropDown.propTypes = {
    context: PropTypes.object.isRequired,
    bcpRequest: PropTypes.object.isRequired,
    currentColumnValue: PropTypes.string,
    column: PropTypes.object
};